import { useMemo } from 'preact/compat';

import { AnyCard } from '@/queries/cards/types';
import { useSelector } from '@/redux/helper';
import { selectShowsEducatorsApp } from '@/redux/selectors/users';

// eslint-disable-next-line import/prefer-default-export
export const useAccessibleCards = (cards: AnyCard[] | undefined): AnyCard[] | undefined => {
  const showsEducatorsApp = useSelector(selectShowsEducatorsApp);
  return useMemo(() => {
    if (!showsEducatorsApp) {
      return cards?.filter((card) => card.type !== 'LESSON_CARD_TYPE' && card.type !== 'BROWSE_LESSONS_CARD_TYPE');
    }
    return cards;
  }, [cards, showsEducatorsApp]);
};
